import { RBChannel } from 'store/railsBuilder/reducer.types';

import { EventItemWithServiceInfo } from 'services/data-manager/types';

function parseKidsChannels(
    channels: RBChannel[],
    railResponse: EventItemWithServiceInfo[],
) {
    const channelsByChannelId = channels.reduce<Record<string, RBChannel>>(
        (acc, item) => ({
            ...acc,
            [item.editorial.id]: item,
        }),
        {},
    );

    return railResponse.reduce<RBChannel[]>((acc, item) => {
        const channelId = item.channel?.editorial?.id;

        if (channelId && channelsByChannelId[channelId]) {
            return [...acc, channelsByChannelId[channelId]];
        }

        return acc;
    }, []);
}

export default parseKidsChannels;
